/**
 * Preview-only timezone override for testing
 * Read query params to force timezone without changing system settings
 */

export function getPreviewTz() {
  const usp = new URLSearchParams(location.search);
  const forced = usp.get('force_tz');
  return forced || null;
}

export function tzDebugOn() {
  return new URLSearchParams(location.search).get('tzdebug') === '1';
}
